import './App.less';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {commonRoutes} from "./routers";
import React, {useEffect} from "react";
import FrameOut from "./components/layout";
import useSmallScreen from "./hooks/useSmallScreen";

import AOS from 'aos';
import 'aos/dist/aos.css';


function App() {
    const isSmallScreen = useSmallScreen();

    useEffect(() => {
        AOS.init();
    }, []);
    return (
        <div className="App">
            <BrowserRouter>
                <FrameOut homeOnly={isSmallScreen}>
                    <Routes>
                        {/*公共的路由*/}
                        {
                            commonRoutes.map(item => {
                                const page = isSmallScreen && item.pathName !== '/index'
                                    ? <Navigate to="/index" replace/>
                                    : <item.component homeOnly={isSmallScreen}/>;
                                return (<Route path={item.pathName} element={page} key={item.pathName}/>)
                            })
                        }
                        <Route path="/" element={<Navigate to="/index" replace/>}/>
                        <Route path="*" element={<Navigate to={isSmallScreen ? '/index' : '/404'} replace/>}/>
                    </Routes>
                </FrameOut>
            </BrowserRouter>
        </div>
    );
}

export default App;
